import { WHATNOT_CONDITIONS } from "./whatnot.js";
export * from "./whatnot.js";

/**
 * Shared constants for the Farnsworth Suite.
 * Values here are the single source of truth for enum-like string columns.
 */

export const USER_ROLES = ["admin", "manager", "staff"] as const;

export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 32;
/** Usernames are stored lowercase: letters, digits, dot, underscore, hyphen. */
export const USERNAME_PATTERN = "^[a-z0-9._-]+$";

export const ITEM_CONDITIONS = WHATNOT_CONDITIONS;
export const ITEM_HAZMAT_VALUES = ["Not Hazmat", "Hazmat"] as const;

export const FUNKO_BOX_CONDITIONS = ["mint", "damaged", "protector"] as const;

export const FUNKO_STICKER_TYPES = [
  "common",
  "flocked",
  "glow",
  "metallic",
  "chrome",
  "diamond",
  "SDCC",
  "NYCC",
  "ECCC",
  "exclusive",
] as const;

export const PRICE_SOURCES = ["manual", "ppg", "ebay-sold", "gt-poppedia", "system"] as const;

/** Marketplaces an item can be listed on / sold through (from fc-inventory-app). */
export const SALE_PLATFORMS = [
  "Whatnot",
  "eBay",
  "Mercari",
  "Facebook",
  "Direct Sale",
  "Other",
] as const;

/** Shipping weight buckets used for Whatnot/listing export (from fc-inventory-app). */
export const POP_WEIGHTS = [
  "0-1 oz",
  "1-3 oz",
  "4-7 oz",
  "8-11 oz",
  "12-15 oz",
  "1 lb",
  "1-2 lbs",
  "2-3 lbs",
  "3-4 lbs",
  "4-6 lbs",
  "10-14 lbs",
] as const;

/**
 * Default values for the Whatnot bulk-upload template columns. These carry
 * over from the legacy app. Inventory uses the classification defaults on create;
 * only Listing Type and Offerable remain metadata overrides on export.
 *
 * Category/Sub Category use the canonical operator-supplied Whatnot taxonomy.
 * Conditions use the exact supplied category/subcategory-specific labels.
 */
export const WHATNOT_DEFAULTS = {
  category: "Toys & Hobbies",
  subCategory: "Funko Pop!",
  type: "Buy it Now",
  condition: "Good",
  hazmat: "Not Hazmat",
  offerable: "TRUE",
  shippingProfile: "8-11 oz",
} as const;

/** Template column order for the Whatnot bulk-upload CSV. */
export const WHATNOT_HEADERS = [
  "Category",
  "Sub Category",
  "Title",
  "Description",
  "Quantity",
  "Type",
  "Price",
  "Shipping Profile",
  "Offerable",
  "Hazmat",
  "Condition",
  "Cost Per Item",
  "SKU",
  "Image URL 1",
  "Image URL 2",
  "Image URL 3",
  "Image URL 4",
  "Image URL 5",
  "Image URL 6",
  "Image URL 7",
  "Image URL 8",
] as const;

export const AUDIT_ACTIONS = ["create", "update", "delete"] as const;

export const AGENT_PROFILES = ["inventory", "funk", "social"] as const;

export const AGENT_EVENT_TYPES = [
  "stock_alert",
  "price_update",
  "social_post",
  "duplicate_audit",
  "sku_normalize",
] as const;

export const AGENT_EVENT_STATUSES = [
  "pending",
  "processing",
  "completed",
  "failed",
] as const;

/** Default pagination bounds for list endpoints. */
export const PAGINATION = {
  defaultLimit: 25,
  maxLimit: 100,
} as const;

/** Cookie names used for human sessions. */
export const AUTH_COOKIES = {
  access: "farnsworth_access",
  refresh: "farnsworth_refresh",
} as const;

/** Header carrying the agent API key. */
export const API_KEY_HEADER = "x-api-key";
